var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "checkout-order h-100" },
    [
      _vm.stage == _vm.CHECKOUT.HOME
        ? _c("checkout-home", {
            staticClass: "checkout-order--component delivery-mode",
            attrs: {
              order: _vm.order,
              modal: _vm.modal,
              "save-on-dismiss": true,
            },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.CHOOSE_SHOP
        ? _c("stage-choose-shop", {
            staticClass: "checkout-order--component stage-choose-shop",
            attrs: { mode1: true, order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.EDIT_ADDRESS
        ? _c("edit-address", {
            staticClass: "checkout-order--component checkout-address",
            attrs: { address: _vm.param, order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go, "set-address": _vm.setAddress },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.DELIVERY_DATE
        ? _c("delivery-date", {
            staticClass: "checkout-order--component delivery-date",
            attrs: { mode1: true, order: _vm.order, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "text-danger",
          staticStyle: { "font-weight": "bold", "margin-left": "15px" },
        },
        [_vm._v(_vm._s(_vm.CheckoutService.errorMsg))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }